let apiBaseUrl = "//sarudoli.axiohm.cz/api";
let uploadsUrl = "//sarudoli.axiohm.cz/result-pdfs";

if (process.env.NODE_ENV !== "production") {
  apiBaseUrl = "//localhost/api";
  uploadsUrl = "//localhost/result-pdfs";
}

const API_URL = apiBaseUrl;
const UPLOADS_URL = uploadsUrl;

export { API_URL, UPLOADS_URL };
